module.exports = __webpack_public_path__ + "static/monitoring_fin_V2-d5ae0c3c267c1051e4ab24b8a4f7b2e5.mp4";